<div class="share-media-root">
@if (loading) {
  <div class="page-loader">
    <div class="spinner"></div>
    <span>Loading media</span>
  </div>
} @else if (!enabled) {
  <div class="page-message">
    <svg class="page-message-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1 1M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1-1M3 3l18 18" />
    </svg>
    <h1>This link is no longer active</h1>
    <p>Ask the person who shared it for a new link.</p>
  </div>
} @else if (!products.length) {
  <div class="page-message">
    <svg class="page-message-icon" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="9" cy="9" r="2" />
      <path d="m21 15-5-5L5 21" />
    </svg>
    <h1>No shared media</h1>
    <p>There are no photos in this link yet.</p>
  </div>
} @else {
  <div class="layout" [class.menu-open]="menuOpen">
    <aside class="sidebar">
      <div class="sidebar-header">
        <span class="eyebrow">Collection index</span>
        <button class="icon-button mobile-only" type="button" aria-label="Close menu" (click)="menuOpen = false">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
        </button>
      </div>

      <nav class="menu">
        @for (brand of menu; track brand.key) {
          <div class="menu-brand">
            <button class="menu-toggle level-brand" type="button" (click)="toggleMenuNode(brand.key)">
              <svg class="chevron" [class.open]="isMenuNodeOpen(brand.key)" viewBox="0 0 24 24" aria-hidden="true">
                <path d="m9 6 6 6-6 6" />
              </svg>
              {{ brand.label }}
            </button>

            @if (isMenuNodeOpen(brand.key)) {
              @for (collection of brand.collections; track collection.key) {
                <button class="menu-toggle level-collection" type="button" (click)="toggleMenuNode(collection.key)">
                  <svg class="chevron" [class.open]="isMenuNodeOpen(collection.key)" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="m9 6 6 6-6 6" />
                  </svg>
                  {{ collection.label }}
                </button>

                @if (isMenuNodeOpen(collection.key)) {
                  @for (styleGroup of collection.styleGroups; track styleGroup.key) {
                    <button class="menu-toggle level-group" type="button" (click)="toggleMenuNode(styleGroup.key)">
                      <svg class="chevron" [class.open]="isMenuNodeOpen(styleGroup.key)" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="m9 6 6 6-6 6" />
                      </svg>
                      {{ styleGroup.label }}
                    </button>

                    @if (isMenuNodeOpen(styleGroup.key)) {
                      @for (product of styleGroup.products; track product.modelId) {
                        <button
                          class="menu-product"
                          type="button"
                          [class.active]="product.modelId === activeModelId"
                          (click)="scrollToProduct(product)"
                        >
                          <span class="menu-product-code">{{ product.code }}</span>
                          <span class="menu-product-count">{{ product.shots.length }}</span>
                        </button>
                      }
                    }
                  }
                }
              }
            }
          </div>
        }
      </nav>
    </aside>

    <div class="sidebar-backdrop" (click)="menuOpen = false"></div>

    <main class="content">
      <header class="topbar">
        <button class="icon-button mobile-only" type="button" aria-label="Open menu" (click)="menuOpen = true">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
        </button>

        <div class="topbar-title">
          <span class="eyebrow">Shared media</span>
          <span class="topbar-counts">{{ products.length }} products · {{ allShots.length }} photos</span>
        </div>

        <button class="download-button" type="button" [disabled]="downloading" (click)="downloadImagesByMediaShareLinkId()">
          @if (downloading) {
            <span class="spinner small"></span>
            Preparing
          } @else {
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4v11m0 0-4-4m4 4 4-4M5 20h14" /></svg>
            Download all
          }
        </button>
      </header>

      @for (product of renderedProducts; track product.modelId) {
        <section class="product" [id]="product.anchorId" [attr.data-model-id]="product.modelId" #productSection>
          <div class="product-caption reveal" #reveal>
            <span class="product-path">{{ product.brand }} / {{ product.collection }} / {{ product.styleGroup }}</span>
            <h2>
              {{ product.code }}
              <span class="product-name">{{ product.name }}</span>
            </h2>
          </div>

          @if (product.shots.length) {
            <div class="masonry">
              @for (column of product.columns; track $index) {
              <div class="masonry-column">
              @for (shot of column; track shot.key) {
                <figure
                  class="tile reveal"
                  #reveal
                  [class.is-loaded]="loadedShots.has(shot.key)"
                  [class.is-failed]="failedShots.has(shot.key)"
                  (click)="openLightbox(shot)"
                >
                  @if (shot.video) {
                    <video
                      [src]="shot.src"
                      muted
                      playsinline
                      preload="metadata"
                      (loadeddata)="onShotLoaded(shot)"
                      (error)="onShotFailed(shot)"
                    ></video>
                    <span class="play-badge" aria-hidden="true">
                      <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
                    </span>
                  } @else {
                    <img
                      [src]="shot.src"
                      [alt]="product.code + ' ' + shot.label"
                      loading="lazy"
                      decoding="async"
                      (load)="onShotLoaded(shot)"
                      (error)="onShotFailed(shot)"
                    />
                  }
                  <figcaption>{{ shot.label }}</figcaption>
                  @if (failedShots.has(shot.key)) {
                    <span class="tile-error">Image unavailable</span>
                  }
                </figure>
              }
              </div>
              }
            </div>
          } @else {
            <p class="product-empty">No photos available for this product.</p>
          }
        </section>
      }

      @if (hasMoreProducts) {
        <div class="load-more" #loadMoreSentinel>
          <span class="spinner"></span>
        </div>
      } @else {
        <footer class="end-of-gallery">End of gallery</footer>
      }
    </main>
  </div>
}

@if (lightboxShot; as shot) {
  <div class="lightbox" (click)="closeLightbox()">
    <button class="lightbox-close icon-button" type="button" aria-label="Close" (click)="closeLightbox()">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
    </button>
    <button
      class="lightbox-nav prev icon-button"
      type="button"
      aria-label="Previous photo"
      (click)="$event.stopPropagation(); showPreviousShot()"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 6-6 6 6 6" /></svg>
    </button>

    <figure class="lightbox-figure" (click)="$event.stopPropagation()">
      @if (shot.video) {
        <video [src]="shot.src" controls autoplay playsinline></video>
      } @else {
        <img [src]="shot.src" [alt]="shot.label" />
      }
      <figcaption>{{ shot.label }}</figcaption>
    </figure>

    <button
      class="lightbox-nav next icon-button"
      type="button"
      aria-label="Next photo"
      (click)="$event.stopPropagation(); showNextShot()"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6" /></svg>
    </button>
  </div>
}
</div>
